import { render, staticRenderFns } from "./contentReviewCourse.vue?vue&type=template&id=76731d84&"
import script from "./contentReviewCourse.vue?vue&type=script&lang=js&"
export * from "./contentReviewCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports